// extracted by mini-css-extract-plugin
export default {"emailEdit":"G9vnod","emailLabel":"hcknGp","editEmailButton":"wJKbIM"};